// extracted by mini-css-extract-plugin
export default {"border":"student_border__A-tS2","color":"student_color__suMe5"};